import { SearchCriteria } from "../../search-criterias/search-criteria";

export class ClientsLoyaltyPointInfoSearchCriteria extends SearchCriteria {

  constructor() {
    super();
  }
  public ClientId: number;
}
